const auth: {
	keys: {
		[key: string]: string;
	};
	safariWebIds: {
		[key: string]: string;
	};
} = {
	keys: {
		local: "8c7c450b-5dbd-48e3-ad29-dba271f81a4c",
		development: "f24ba143-4ede-4c44-99f2-ab6b6a72acb2",
		production: "3254253c-772c-465d-b567-908333208338",
	},
	safariWebIds: {
		local: "web.onesignal.auto.2900aeea-27da-4bc5-9f95-2e3d9a76781c",
		development: "web.onesignal.auto.0b3c1e09-f01e-4f75-a6ff-3f857f927766",
		production: "web.onesignal.auto.25811132-3882-4d1b-a1e7-3632ed052841",
	},
};

export default auth;
